<script>
import InputSelect from './InputSelect.vue'
import InputText from './InputText.vue'
import $ from "jquery";
import { onMounted, ref, computed, watch, reactive, nextTick, toRaw } from "vue";
import Recaptcha from '../../common/components/Recaptcha.vue'
import { useForm } from 'vee-validate';
import * as yup from 'yup';

export default {
  name: 'PageLandingGenerique',

  components: {
    InputSelect,
    InputText,
    Recaptcha,
  },

  props: {
    optin: {
      type: String,
      default: '',
    },
    hasmezzo: {
      type: String,
      default: "0",
    },
  },

  setup(props){
    const selects = reactive({
        business_sector: [
          'Industrie',
          'Immobilier',
          'Collectivités locales',
          'Agriculture',
          'Copropriété',
          'Hôtel / Restaurant',
          'Commerce',
          'Garage',
          'TPE/PME',
          'EHPAD',
          'Autre secteur',
        ],
      })

      const isPosted = ref(false)
      const captchaError = ref(false)
      const recaptcha = ref(null)

      const form = reactive( {
        business_sector: '',
        company_name: '',
        firstname: '',
        lastname: '',
        email: '',
        phone: '',
        telephone: '',
        zipcode: '',
        captcha: '',
        mention: '',
        specify_your_request: '',
        mezzo: props.hasmezzo,
      })

      const { values, errors, defineField, validate } = useForm({

        validationSchema: yup.object({
          business_sector: yup.string().required('ce champ est requis'),
          company_name: yup.string().required('ce champ est requis'),
          lastname: yup.string().required('Le nom est requis'),
          firstname: yup.string().required('Le prénom est requis'),
          email: yup.string().email('L\'email est invalide').required('L\'email est requis'),
          telephone: yup
            .string()
            .matches(/^(0|\+33)[0-9]{9}$/, 'Le numéro de téléphone est invalide')
            .required('Le téléphone est requis'),
          zipcode: yup.number().required('Le code postal est requis').typeError('Un numéro valide est requis'),
            }),
      });

    const [business_sector, business_sectorAttrs] = defineField('business_sector', {
      validateOnMount: false,
      validateOnChange: true,
      validateOnBlur: true,
    });
    const [company_name, company_nameAttrs] = defineField('company_name', {
      validateOnMount: false,
      validateOnChange: true,
      validateOnBlur: true,
    });
    const [telephone, telephoneAttrs] = defineField('telephone', {
      validateOnMount: false,
      validateOnChange: true,
      validateOnBlur: true,
    });
    const [zipcode, zipcodeAttrs] = defineField('zipcode', {
      validateOnMount: false,
      validateOnChange: true,
      validateOnBlur: true,
    });
    const [lastname, lastnameAttrs] = defineField('lastname', {
      validateOnMount: false,
      validateOnChange: true,
      validateOnBlur: true,
    });
    const [firstname, firstnameAttrs] = defineField('firstname', {
      validateOnMount: false,
      validateOnChange: true,
      validateOnBlur: true,
    });

    const [email, emailAttrs] = defineField('email', {
      validateOnMount: false,
      validateOnChange: true,
      validateOnBlur: true
    });

      const formEl = ref(null)
      const gtmProduit = ref(null)
      const gtmCiblePrincipale= ref(null)
      const gtmCibleMetier= ref(null)
      const category= ref(null)

      const showForm = computed(() => {
        return !isPosted.value
    });
    const showConfirmation = computed(() => {
      return isPosted.value
    });
    const hasTestimony = computed(() => {
      return hasOwnProperty('testimony')
    });

    onMounted(async () => {
      await nextTick()
    formEl.value = document.querySelector('form')
    isPosted.value = formEl.value.querySelector('.webform-confirmation') !== null
    const formSection = document.querySelector('.form__section')

    if (
      formSection &&
      formSection.classList.contains('lp_generique_professionnel')
    ) {
      category.value = 'Pro'
    } else{
      category.value = 'Particulier'
    }
    formEl.value.addEventListener("submit", function(event) {
      if(category.value === 'Particulier'){
        event.preventDefault()
        const lastname_val = document.querySelector('#edit-lastname').value
        const firstname_val = document.querySelector('#edit-firstname').value
        const zipcode_val = document.querySelector('#edit-zipcode').value
        const email_val = document.querySelector('#edit-email').value
        const specify_your_request_val = document.querySelector('#edit-specify-your-request').value
        const optin_val = document.querySelector('.form-checkbox').checked
        const telephone_val = document.querySelector('#edit-phone').value
        const mezzo_val = document.querySelector('[name="mezzo"]').value
        form.business_sector= category.value
        form.company_name= ''
        form.firstname= firstname_val
        form.lastname= lastname_val
        form.email= email_val
        form.phone= telephone_val
        form.telephone= telephone_val
        form.zipcode= zipcode_val
        form.mention=  optin_val ? document.querySelector(".form-checkbox").value : ''
        form.specify_your_request= specify_your_request_val
        form.mezzo= mezzo_val

        sendForm()
      }
    })


    window.dataLayer = window.dataLayer || [];
    var itemToPush = {};
    // Page title (pagename)
    var H1 = jQuery('h1');
    if (H1.length) {
      itemToPush['pagename'] = H1.text().replace(/["+?!]/g,'').replace(/[#_', ]/g,'_').normalize("NFD").replace(/[\u0300-\u036f]/g, "");
    }
    itemToPush['pagetype'] = 'Landing page';
    itemToPush['event'] = "page_load";
    window.dataLayer.push(itemToPush);
    $(document).ready(function() {
        $('#edit-principal-form .form-item:not(.form-item-specify-your-request):not(.form-item-optin-optin-value) input')
            .on('focus', function() {
                $(this).parent().addClass('has-focus');
            })
            .on('blur', function() {
                if ($(this).val() === "") {
                    $(this).parent().removeClass('has-focus');
                }
            });
    });

    // If position: sticky is not supported, add a workaround to make form sticky
    // (in I.E. for example)
    if (
      window.CSS === undefined ||
      !window.CSS.supports('position', 'sticky')
    ) {
      let contentContainer = document.querySelector('.content')
      let formColumn = contentContainer.querySelector('.form')
      let formContainer = formColumn.querySelector('.form__section')
      formColumn.classList.add('sticky-workaround')

      window.addEventListener('scroll', () => {
        if (window.innerWidth > 1059) {
          let scrollY = window.pageYOffset

          formContainer.style.setProperty(
            'top',
            Math.max(0, scrollY - formColumn.offsetTop) + 'px'
          )
          formContainer.style.setProperty('bottom', '')

          if (scrollY > formColumn.offsetTop) {
            let formContainerBottom =
              formContainer.offsetTop + formContainer.offsetHeight
            if (formContainerBottom >= formColumn.offsetHeight) {
              formContainer.style.setProperty('top', 'auto')
              formContainer.style.setProperty('bottom', '0')
            }
          }
        }
      })
    }
  });

  function updateDatalayer(formData) {
      // First let's format the form_name
      formData.form_name = formData.form_name
        .trim()
        .replace(/[#_',/]/g, '_')
        .replace(/["+?! ]/g, '')
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')

      // format the form category
      formData.form_category = formData.form_category
        .trim()
        .replace(/["+?! ]/g, '')
        .replace(/[#_',/]/g, '_')
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
      // Then push it to the data layer
      window.dataLayer.push(formData)
    }

    function onCaptchaExpired() {
      recaptcha.value.reset()
      captchaError.value = true
    }

    function onCaptchaVerified(token) {
      recaptcha.value.reset()
      form.captcha = token
      submitForm()
    }

    function  checkRecaptcha() {
      captchaError.value = false
      if(category.value == "Pro") {
          recaptcha.value.execute()
      }
    }

    const submitForm = () => {
      if(category.value === "Pro"){
        validate()
        .then((result) => {
          if (result.valid && form.captcha.length > 0) {
            sendForm()
          }
        })
        .catch((e) => {
          console.log(e)
        })
      }
    };

    function sendForm() {

      if(category.value === 'Pro'){
        form.lastname = lastname
        form.firstname = firstname
        form.telephone = telephone
        form.phone = telephone
        form.email = email
        form.company_name = company_name
        form.business_sector = business_sector
        form.zipcode = zipcode
      }
      const paritculier_category = 'particulier'
      // const formSection = document.querySelector('.form__section')

      // if (
      //   formSection &&
      //   formSection.classList.contains('lp_generique_professionnel')
      // ) {
      //   category = 'professionnel'
      // }

      // Send Google tags
      gtmProduit.value = document.querySelector('#gtm-produit').innerHTML
      gtmCiblePrincipale.value = document.querySelector(
        '#gtm-cible-principale'
      ).innerHTML
      gtmCibleMetier.value = document.querySelector(
        '#gtm-cible-metier'
      ).innerHTML

      const formData = {
        event: 'form_confirmation',
        form_type: 'Landing_generique',
        form_name: document.querySelector('h1.title.title--1').textContent,
        form_category: form.business_sector ? form.business_sector : paritculier_category,
        event_detail: gtmProduit.value,
      }

      window.dataLayer = window.dataLayer || []
      dataLayer.push({
        event: 'formulaireContact-Validation',
        produit: gtmProduit.value,
        ciblePrincipale: gtmCiblePrincipale.value,
        cibleMetier: gtmCibleMetier.value,
      })

      // Submit form
      for (let [key, value] of Object.entries(form)) {
        let input = formEl.value.querySelector(`[name='${key.toLowerCase()}']`)
        if (input) {
          switch (key) {
            case 'mention':
              input.value = value ? props.optin : ''
              break
            case 'acceptance':
              input.value = 'Envoyer mon email'
              break
            default:
              input.value = value
              break
          }
        }
      }

      updateDatalayer(formData)
      formEl.value.submit()

    }

    return {
      updateDatalayer,
      sendForm,
      submitForm,
      checkRecaptcha,
      recaptcha,
      onCaptchaVerified,
      onCaptchaExpired,
      hasTestimony,
      showConfirmation,
      showForm,
      category,
      gtmCibleMetier,
      gtmCiblePrincipale,
      gtmProduit,
      formEl,
      selects,
      isPosted,
      form,
      captchaError,
      email,
      firstname,
      lastname,
      business_sector,
      zipcode,
      telephone,
      company_name,
      errors,
      values
    }
  }
}
</script>

<style lang="sass">
@import ../../common/styles/mixins
@import ../../common/styles/settings
@import "PageLandingGenerique"
@import "formLandingGenerique"
</style>
